import styles from '../../../styles/modules/ui-components/carosel.module.scss';
import { partnersScrolled } from '../../../tracking/segment/homePage';

export const PrevArrow = (props:any) => { 
  const scrollClicked = () => {
    if(props.type && props.type=='partners'){
      partnersScrolled({})
    }
  } 
  return(
    <a className={`${styles._arrow} ${styles._arrow_prev} ${props.className}`} onClick={()=> {scrollClicked();props.onClick()}} style={props.customStyle? props.customStyle : {}}></a>
  );
}


export const NextArrow = (props:any) => {
  const scrollClicked = () => {
    if(props.type && props.type=='partners'){
      partnersScrolled({})
    }
  }
  return(
    <a className={`${styles._arrow} ${styles._arrow_next} ${props.className}`} onClick={()=> {scrollClicked();props.onClick()}} style={props.customStyle? props.customStyle : {}}></a>
  );
}